import { render, staticRenderFns } from "./QaManageDialog.vue?vue&type=template&id=cc26f1ba&scoped=true&"
import script from "./QaManageDialog.vue?vue&type=script&lang=js&"
export * from "./QaManageDialog.vue?vue&type=script&lang=js&"
import style0 from "./QaManageDialog.vue?vue&type=style&index=0&id=cc26f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc26f1ba",
  null
  
)

export default component.exports